import { NavLink } from 'react-router-dom'
import css from './SidebarLink.module.scss'
import jscolors from "../../styles/jscolors.module.scss"

export default function SidebarLink({
	link = '#',
	title,
	iconName,
	notification = null,
	isSubLink,
	isFirst,
	isOpen,
	iconRight,
	iconRightColor,
	isExternal,
	showNotification = false,
	status,
}) {
	return (
		<NavLink to={!isExternal && link} onClick={() => isExternal && window.open(link, '_self')}>
			{({ isActive }) => (
				<div
					className={`
               ${css['link']} 
               ${isActive && !isExternal ? css['active'] : ''} 
               ${isSubLink ? css['sublink'] : ''} 
               ${isFirst ? css['first'] : ''} 
               `}>
					{/* ${!isOpen ? css["vertical"] : ""} */}
					<i className={`fad fa-${iconName}`} />
					<span>{title}</span>
					{/* {isOpen &&  */}

					{showNotification == true &&
						(notification == undefined ? (
							<i className='fad fa-spinner fa-spin' />
						) : (
							<p className={css['notification']}>{notification}</p>
						))}

					{iconRight && (
						<i style={{ color: jscolors[iconRightColor] }} className={`fas fa-${iconRight}`} />
					)}
				</div>
			)}
		</NavLink>
	)
}
